/**
 * Browser content accessors — CMS removed.
 * No remote API, no revision polling, no session cache of CMS payloads.
 */

const STATIC_CONTACT = {
  contact_email: 'support@airestro360.com',
  contact_phone: '+923012775034',
  contact_address: 'Islamabad, Pakistan',
}

const STATIC_LEGAL_NAV = {
  terms: true,
  'privacy-policy': true,
  'about-us': true,
  'cookie-policy': true,
  disclaimer: true,
}

export function clearCmsApiCache() {}

export async function prepareCmsClient() {}

export function startRevisionPolling() {}

export function getPages() {
  return Promise.resolve({ pages: [] })
}

export function getPageBySlug() {
  return Promise.resolve({})
}

export function getBlogs() {
  return Promise.resolve({ blogs: [], json_ld: null })
}

export function getBlogBySlug() {
  return Promise.resolve({})
}

export function getContactSettings() {
  return Promise.resolve({ ...STATIC_CONTACT })
}

/**
 * Contact form — opens the visitor's mail client (no CMS backend).
 */
export function submitContactForm(data) {
  const to = STATIC_CONTACT.contact_email
  const subject = encodeURIComponent(String(data?.subject || 'Contact'))
  const body = encodeURIComponent(
    `Name: ${data?.name || ''}\nEmail: ${data?.email || ''}\n\n${data?.message || ''}`,
  )
  if (typeof window !== 'undefined') {
    window.location.href = `mailto:${to}?subject=${subject}&body=${body}`
  }
  return Promise.resolve({ success: true })
}

export function getFaq() {
  return Promise.resolve({ faq: [] })
}

export function getHomeCards() {
  return Promise.resolve({ cards: [], section: null })
}

export function getSections() {
  return Promise.resolve({ sections: [] })
}

export function getHomePageContent() {
  return Promise.resolve({ content: '', json_ld: null })
}

export function getToolSchemaJsonLd() {
  return Promise.resolve({})
}

export function getHomeSeo() {
  return Promise.resolve({ content: '', json_ld: null })
}

export function getLegalPage(slug) {
  // Legal HTML is rendered server-side from @/content/staticPages — client stub only.
  void slug
  return Promise.resolve({})
}

export function getLegalNav() {
  return Promise.resolve({ legal: { ...STATIC_LEGAL_NAV } })
}

export function getContentLocales() {
  return Promise.resolve({ locales: ['en', 'ar'] })
}
